(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * A service that provides information about a User's security roles.
   */
  factory('UserRoles', ['OrganizationSettings', function (OrganizationSettings) {
    function hasSystemRole(user, role) {
      return user === null ? false : user.subject.roles.indexOf(role) >= 0;
    }
    function hasOrgRole(user, role) {
      return user.membership ? role === user.membership.role : false;
    }
    var self = {
      isSystemAdmin: function isSystemAdmin(user) {
        return hasSystemRole(user, "admin");
      },
      isWatershedUser: function isWatershedUser(user) {
        return hasSystemRole(user, "watersheduser");
      },
      isOrgAdmin: function isOrgAdmin(user) {
        return this.isSystemAdmin(user) || hasOrgRole(user, "admin");
      },
      isConsultant: function isConsultant(user) {
        return hasOrgRole(user, "consultant");
      },
      isOrgManager: function isOrgManager(user) {
        return this.isOrgAdmin(user) || hasOrgRole(user, 'manager');
      },
      isWatershedEmployee: function isWatershedEmployee(user) {
        return hasSystemRole(user, "watershed-employee");
      },
      isViewDashboardsAsAllowed: function isViewDashboardsAsAllowed(user) {
        return this.isOrgAdmin(user);
      },
      isExploreAllowed: function isExploreAllowed(user) {
        return this.isOrgAdmin(user);
      },
      getAllRoles: function getAllRoles(user) {
        var roles = [{
          name: "User",
          id: "user",
          description: "A simple user"
        }];
        if (self.isOrgManager(user) || self.isOrgAdmin(user)) {
          roles.push({
            name: "Area Admin",
            id: "manager",
            description: "A user capable of inviting and viewing user in their area"
          });
        }
        if (self.isOrgAdmin(user)) {
          roles.push({
            name: "Global Admin",
            id: "admin",
            description: "Highest level of permissions"
          });
        }
        if (self.isOrgAdmin(user) && OrganizationSettings.hasFeature('userRoles')) {
          roles.splice(1, 0, {
            name: "Consultant",
            id: "consultant",
            description: "A user capable of seeing all data but no PII"
          });
        }
        return roles;
      }
    };
    return self;
  }]);
})();
